/* eslint-disable no-underscore-dangle */
import BaseService from './BaseService';

class ResourceService extends BaseService {}

export default ResourceService;
